import { ReactElement } from "react";
import { Typography } from "@altimateai/lego";
import { Stack } from "@altimateai/lego";

export function MissingLineage(): ReactElement {
  return (
    <div className="al-py-[50px] al-rounded al-bg-background al-text-center">
      <Stack className="al-pt-4" align={"center"} direction={"column"} justify="center">
        <Typography variant="h3" className="al-text-muted-foreground">
          No Lineage Found
        </Typography>
        <Typography variant="body" className="al-mb-4 al-mt-2 al-text-muted-foreground">
          This lineage information is incomplete. Please tag queries to get detailed lineage information
          information
        </Typography>
      </Stack>
    </div>
  );
}
